// --- Configuration & Data ---
const dictionary = {
	嫁娶: "Wedding",
	祭祀: "Sacrifice",
	祈福: "Prayer",
	求嗣: "Pray Child",
	动土: "Break Grnd",
	开市: "Open Biz",
	交易: "Trading",
	出行: "Travel",
	移徙: "Move House",
	安床: "Install Bed",
	修造: "Renovate",
	纳畜: "Livestock",
	入宅: "Enter House",
	安葬: "Funeral",
	沐浴: "Bathing",
	理发: "Haircut",
	破土: "Break Grnd",
	解除: "Relieve",
	拆卸: "Demolish",
	栽种: "Planting",
	纳采: "Betrothal",
	订盟: "Engagement",
	安香: "Incense",
	出火: "Move Deity",
	诸事不宜: "No Activity",
	安门: "Install Door",
	作灶: "Fix Stove",
	探病: "Visit Sick",
	诉讼: "Lawsuit",
	掘井: "Dig Well",
	分居: "Separate",
	坏垣: "Fix Wall",
	余事勿取: "Avoid Else",
};
const translate = (arr) =>
	arr.map((term) => dictionary[term] || term).filter((t) => /^[A-Za-z\s\/]+$/.test(t));
const stems = {
	甲: "Jia",
	乙: "Yi",
	丙: "Bing",
	丁: "Ding",
	戊: "Wu",
	己: "Ji",
	庚: "Geng",
	辛: "Xin",
	壬: "Ren",
	癸: "Gui",
};
const branches = {
	子: "Zi",
	丑: "Chou",
	寅: "Yin",
	卯: "Mao",
	辰: "Chen",
	巳: "Si",
	午: "Wu",
	未: "Wei",
	申: "Shen",
	酉: "You",
	戌: "Xu",
	亥: "Hai",
};
const zodiacMap = {
	鼠: "Rat",
	牛: "Ox",
	虎: "Tiger",
	兔: "Rabbit",
	龙: "Dragon",
	蛇: "Snake",
	马: "Horse",
	羊: "Goat",
	猴: "Monkey",
	鸡: "Rooster",
	狗: "Dog",
	猪: "Pig",
};
const dirMap = {
	东: "East",
	南: "South",
	西: "West",
	北: "North",
	中: "Center",
	东南: "SE",
	东北: "NE",
	西南: "SW",
	西北: "NW",
};
const lunarMonths = {
	正: "1st",
	二: "2nd",
	三: "3rd",
	四: "4th",
	五: "5th",
	六: "6th",
	七: "7th",
	八: "8th",
	九: "9th",
	十: "10th",
	冬: "11th",
	腊: "12th",
};
const numMap = {
	初一: "1st",
	初二: "2nd",
	初三: "3rd",
	初四: "4th",
	初五: "5th",
	初六: "6th",
	初七: "7th",
	初八: "8th",
	初九: "9th",
	初十: "10th",
	十一: "11th",
	十二: "12th",
	十三: "13th",
	十四: "14th",
	十五: "15th",
	十六: "16th",
	十七: "17th",
	十八: "18th",
	十九: "19th",
	二十: "20th",
	廿一: "21st",
	廿二: "22nd",
	廿三: "23rd",
	廿四: "24th",
	廿五: "25th",
	廿六: "26th",
	廿七: "27th",
	廿八: "28th",
	廿九: "29th",
	三十: "30th",
};

function toPinyin(str) {
	let res = "";
	for (let char of str) {
		if (stems[char]) res += stems[char] + " ";
		else if (branches[char]) res += branches[char] + " ";
		else res += char;
	}
	return res.trim();
}

let selectedDate = new Date();
let currentYear = selectedDate.getFullYear();
let currentMonth = selectedDate.getMonth();

window.onload = () => {
	initSelectors();
	renderApp();
};

function initSelectors() {
	const ySelect = document.getElementById("yearSelect");
	const mSelect = document.getElementById("monthSelect");
	for (let y = 1900; y <= 2100; y++) ySelect.add(new Option(y, y, y === currentYear, y === currentYear));
	[
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	].forEach((m, i) => mSelect.add(new Option(m, i, i === currentMonth, i === currentMonth)));
	ySelect.onchange = (e) => {
		currentYear = parseInt(e.target.value);
		selectedDate.setFullYear(currentYear);
		renderApp();
	};
	mSelect.onchange = (e) => {
		currentMonth = parseInt(e.target.value);
		selectedDate.setMonth(currentMonth);
		renderApp();
	};
}

function renderApp() {
	renderCalendarWidget();
	renderDetailsPanel();
}

function renderCalendarWidget() {
	const grid = document.getElementById("miniCalendarGrid");
	const title = document.getElementById("calendarTitle");
	grid.innerHTML = "";
	const months = [
		"JANUARY",
		"FEBRUARY",
		"MARCH",
		"APRIL",
		"MAY",
		"JUNE",
		"JULY",
		"AUGUST",
		"SEPTEMBER",
		"OCTOBER",
		"NOVEMBER",
		"DECEMBER",
	];
	title.innerText = months[currentMonth];

	const firstDay = new Date(currentYear, currentMonth, 1).getDay();
	const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
	const prevMonthDays = new Date(currentYear, currentMonth, 0).getDate();

	for (let i = 0; i < firstDay; i++)
		grid.appendChild(createMiniCell(prevMonthDays - firstDay + 1 + i, true));
	for (let i = 1; i <= daysInMonth; i++) grid.appendChild(createMiniCell(i, false));
	const totalCells = firstDay + daysInMonth;
	const rows = Math.ceil(totalCells / 7);
	const remaining = rows * 7 - totalCells;
	for (let i = 1; i <= remaining; i++) grid.appendChild(createMiniCell(i, true));
}

function createMiniCell(day, isGray) {
	const cell = document.createElement("div");
	const isSelected =
		!isGray &&
		day === selectedDate.getDate() &&
		currentMonth === selectedDate.getMonth() &&
		currentYear === selectedDate.getFullYear();
	let cellDate = isGray
		? new Date(currentYear, currentMonth + 1, day)
		: new Date(currentYear, currentMonth, day);

	const lunar = Lunar.fromDate(cellDate);
	let lunarTxt = lunar.getDayInChinese();

	// Removed xs: refs, used min-[375px]: and arbitrary values
	let baseClass =
		"aspect-square flex flex-col items-center justify-center cursor-pointer rounded-lg relative tap-highlight-transparent ";
	let numberClass = "text-sm min-[375px]:text-base font-semibold  ";
	let lunarClass = "text-[9px] min-[375px]:text-[10px] font-serif mt-[1px] ";

	if (isGray) {
		baseClass += "text-gray-300";
		lunarClass += "text-gray-200";
	} else {
		const fest = lunar.getFestivals()[0];
		const term = lunar.getJieQi();
		let isSpecial = false;
		if (fest) {
			lunarTxt = fest.substring(0, 3);
			isSpecial = true;
		} else if (term) {
			lunarTxt = term;
			isSpecial = true;
		}

		if (isSelected) {
			// Replaced bg-brand with bg-[#B48E25]
			// Replaced shadow-gold-glow with shadow-[0_4px_15px_-3px_rgba(180,142,37,0.5)]
			// Replaced text-brand-lighter with text-[#FEF9E7]
			baseClass +=
				"bg-[#B48E25] text-white shadow-[0_4px_15px_-3px_rgba(180,142,37,0.5)] scale-95 min-[375px]:scale-105 transition-transform";
			lunarClass += "text-[#FEF9E7] opacity-90";
		} else {
			baseClass += "text-gray-700 active:bg-gray-100 lg:hover:bg-gray-50";
			if (isSpecial) {
				// Replaced text-brand with text-[#B48E25]
				lunarClass += "text-[#B48E25] font-bold";
			} else {
				lunarClass += "text-gray-400";
			}
		}
	}

	cell.className = baseClass;
	cell.innerHTML = `<span class="${numberClass}">${day}</span><span class="${lunarClass}">${
		isGray ? "" : lunarTxt
	}</span>`;
	if (!isGray)
		cell.onclick = () => {
			selectedDate = new Date(currentYear, currentMonth, day);
			renderApp();
			window.scrollTo({ top: 0, behavior: "smooth" });
		};
	return cell;
}

function renderDetailsPanel() {
	const lunar = Lunar.fromDate(selectedDate);
	const months = [
		"JANUARY",
		"FEBRUARY",
		"MARCH",
		"APRIL",
		"MAY",
		"JUNE",
		"JULY",
		"AUGUST",
		"SEPTEMBER",
		"OCTOBER",
		"NOVEMBER",
		"DECEMBER",
	];
	const weekdays = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];

	document.getElementById("detailMonthYear").innerText = `${
		months[selectedDate.getMonth()]
	} ${selectedDate.getFullYear()}`;
	document.getElementById("detailDay").innerText = selectedDate.getDate();
	document.getElementById("detailWeekday").innerText = weekdays[selectedDate.getDay()];
	document.getElementById("miniDateDisplay").innerText = `${months[selectedDate.getMonth()].substring(
		0,
		3,
	)} ${selectedDate.getDate()}`;

	const chMonth = lunar.getMonthInChinese();
	const chDay = lunar.getDayInChinese();
	document.getElementById("detailLunarDate").innerText = `${lunarMonths[chMonth] || chMonth} Moon, ${
		numMap[chDay] || chDay
	}`;
	document.getElementById("detailGanZhi").innerText = `${toPinyin(lunar.getDayInGanZhi())} Day`;
	document.getElementById("detailZodiac").innerText =
		zodiacMap[lunar.getYearShengXiao()] || lunar.getYearShengXiao();

	const renderList = (arr, elementId) => {
		const el = document.getElementById(elementId);
		el.innerHTML = "";
		const items = translate(arr).slice(0, 8);
		if (items.length === 0)
			el.innerHTML = `<div class="text-xs text-gray-400 italic col-span-2">None listed</div>`;
		items.forEach((item) => {
			const div = document.createElement("li");
			div.className = "flex items-center gap-2 text-xs text-gray-700 ";
			div.innerHTML = `<span class="w-2 h-2 rounded-full bg-[#e5e7eb]"></span><span class="text-[8px] text-gray-300"></span> <span class="truncate">${item}</span>`;
			el.appendChild(div);
		});
	};
	renderList(lunar.getDayYi(), "yiList");
	renderList(lunar.getDayJi(), "jiList");

	const chong = lunar.getDayChongDesc();
	let clashAnimal = "None";
	Object.keys(zodiacMap).forEach((k) => {
		if (chong.includes(k)) clashAnimal = zodiacMap[k];
	});
	document.getElementById("detailClash").innerText = clashAnimal.toUpperCase();
	const sha = lunar.getDaySha();
	document.getElementById("detailEvil").innerText = (dirMap[sha] || sha).toUpperCase();

	renderTimeGrid(lunar);
}

function renderTimeGrid(lunar) {
	const container = document.getElementById("timeGrid");
	container.innerHTML = "";
	const times = [
		{ t: "23:00-00:59", name: "Early Rat" },
		{ t: "01:00-02:59", name: "Ox" },
		{ t: "03:00-04:59", name: "Tiger" },
		{ t: "05:00-06:59", name: "Rabbit" },
		{ t: "07:00-08:59", name: "Dragon" },
		{ t: "09:00-10:59", name: "Snake" },
		{ t: "11:00-12:59", name: "Horse" },
		{ t: "13:00-14:59", name: "Goat" },
		{ t: "15:00-16:59", name: "Monkey" },
		{ t: "17:00-18:59", name: "Rooster" },
		{ t: "19:00-20:59", name: "Dog" },
		{ t: "21:00-22:59", name: "Pig" },
	];

	times.forEach((slot, index) => {
		const isGood = (index + selectedDate.getDate()) % 2 === 0;
		const div = document.createElement("div");
		// Replaced bg-white, border-[#B48E25]/30, bg-[#FBEFD5], text-[#B48E25]
		div.className = `p-3 min-[375px]:p-4 rounded-xl border ${
			isGood ? "bg-white border-[#B48E25]/30 shadow-sm" : "bg-gray-100/50 border-transparent"
		} flex flex-col gap-1`;
		div.innerHTML = `
            <div class="flex justify-between items-center">
                <span class="text-[10px] min-[375px]:text-xs font-bold text-gray-400 uppercase">${slot.name}</span>
                <span class="text-[9px] font-bold px-1.5 py-0.5 rounded-sm ${
									isGood ? "bg-[#FBEFD5] text-[#B48E25]" : "bg-gray-200 text-gray-500"
								}">${isGood ? "吉" : "平"}</span>
            </div>
            <div class="text-xs min-[375px]:text-sm font-semibold text-gray-800 tracking-tight">${slot.t}</div>
        `;
		container.appendChild(div);
	});
}

function changeMonth(o) {
	currentMonth += o;
	if (currentMonth > 11) {
		currentMonth = 0;
		currentYear++;
	}
	if (currentMonth < 0) {
		currentMonth = 11;
		currentYear--;
	}
	document.getElementById("yearSelect").value = currentYear;
	document.getElementById("monthSelect").value = currentMonth;
	selectedDate = new Date(currentYear, currentMonth, 1);
	renderApp();
}
function changeDay(o) {
	selectedDate.setDate(selectedDate.getDate() + o);
	currentYear = selectedDate.getFullYear();
	currentMonth = selectedDate.getMonth();
	document.getElementById("yearSelect").value = currentYear;
	document.getElementById("monthSelect").value = currentMonth;
	renderApp();
}
